import { NavBar } from "@/features/navBar";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_navbar")({
  component: NavbarRoute
});

function NavbarRoute() {
  return (
    <div className="bg-brand-gray-50 w-full h-screen p-1 grid grid-rows-[40px_1fr] gap-y-2">
      <NavBar />
      <div className="rounded-md overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
}
